import { render, staticRenderFns } from "./DocuformListItemMobile.vue?vue&type=template&id=1bfa2b57&scoped=true"
import script from "./DocuformListItemMobile.vue?vue&type=script&lang=js"
export * from "./DocuformListItemMobile.vue?vue&type=script&lang=js"
import style0 from "./DocuformListItemMobile.vue?vue&type=style&index=0&id=1bfa2b57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa2b57",
  null
  
)

export default component.exports